/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

// ======================================================
// src/pages/MFPartnersPage.jsx
// ======================================================

import React, { useState } from "react";

import NAV from "./nav";
import Carousel from "./carousel";

import MFSubnav from "../components/mf/MFSubnav";
import pru_webQR from "../img/qr/FundzBazar_WebQR.png"
import pru_mobileQR from "../img/qr/FundzBazar_MobileQR.png"
import pru_logo from "../img/logos/prudent_logo.png"
import sbi_logo from "../img/logos/SBI_mf.jpg"
import kotak_logo from "../img/logos/kotak_mf.png"
import aditya_logo from "../img/logos/aditya_birla_mf.jpg"
import nippon_logo from "../img/logos/nippon_mf.png"
import fundbazar_logo from "../img/logos/fundBazar.png"


import {
  ShieldCheck,
  Landmark,
  Sparkles,
  Smartphone,
  QrCode,
  Globe,
  ChevronRight,
  Building2,
} from "lucide-react";
import MFInvestmentModal from "../components/mf/MFInvestmentModal";
import MFFloatingAdvisorWidget from "../components/mf/MFFloatingAdvisorWidget";


// ======================================================
// AMC DATA
// ======================================================

const amcPartners = [

  {
    id: 1,
    name: "ICICI Prudential",
    platform: "FundBazar",
    logo: pru_logo,

    description:
      "Access ICICI Prudential Mutual Funds through the FundBazar investment ecosystem.",

    webLink: "https://fundzbazar.com/Link/8iZ0uvzw-q0",

    mobileLink: "https://fundzbazar.com/Link/h2_ibDRiVoQ",

    qr: pru_webQR,

    features: [
      "SIP & Lumpsum",
      "Online KYC",
      "Portfolio Tracking",
    ],
  },

  {
    id: 2,
    name: "SBI Mutual Fund",
    platform: "SBI MF Platform",
    logo: sbi_logo,

    description:
      "Invest in SBI Mutual Fund schemes with secure online onboarding.",

    webLink: "#",

    mobileLink: "#",

    qr: "/qr/sbi.png",

    features: [
      "Direct AMC Access",
      "Large Fund Selection",
      "Trusted AMC",
    ],
  },

  {
    id: 3,
    name: "Kotak Mutual Fund",
    platform: "Kotak Connect Plus",
    logo: kotak_logo,

    description:
      "Financial Products Distribution made Super Easy.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },

      {
    id: 4,
    name: "Nippon Mutual Fund",
    platform: "Nippon MF",
    logo: nippon_logo,

    description:
      "Wealth Sets you Free.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },


      {
    id: 5,
    name: "Aditya Birla Mutual Fund",
    platform: "ABSLMF Investor App",
    logo: aditya_logo,

    description:
      "Invest Aaj For Kal.",

    webLink: "#",

    mobileLink: "#",

    qr: "#",

    features: [
      "Equity Funds",
      "Debt Funds",
      "Hybrid Allocation",
    ],
  },



];


// ======================================================
// MODAL
// ======================================================

const AMCModal = ({ amc, onClose }) => {

  if (!amc) return null;

  return (

    <div
      className="
        fixed
        inset-0
        z-[999]
        flex
        items-center
        justify-center
        bg-black/60
        backdrop-blur-sm
        p-4
      "
    >

      <div
        className="
          bg-white
          rounded-[32px]
          w-full
          max-w-3xl
          overflow-hidden
          shadow-2xl
          relative
        "
      >

        {/* HEADER */}

        <div
          className="
            bg-gradient-to-r
            from-green-900
            to-green-700
            text-white
            p-8
            relative
          "
        >

          {/*<button*/}
          {/*  onClick={onClose}*/}
          {/*  className="*/}
          {/*    absolute*/}
          {/*    top-5*/}
          {/*    right-5*/}
          {/*    text-white*/}
          {/*    text-xl*/}
          {/*    hover:opacity-70*/}
          {/*  "*/}
          {/*>*/}
          {/*  ✕*/}
          {/*</button>*/}
          <div className="flex justify-end">
          <button
            onClick={onClose}
            className="
              text-white
              text-2xl
              font-light
              hover:opacity-70
              transition-all
              bg-transparent
              border-none
              outline-none
              shadow-none
              p-0
              w-auto
              h-auto
              leading-none
            "
          >
            x
          </button>
          </div>

          <div className="flex items-center gap-5">

            <img
              src={amc.logo}
              alt={amc.name}
              className="
                w-20
                h-20
                rounded-2xl
                object-contain
                bg-white
                p-2
              "
            />

            <div>

              <div className="text-4xl font-black">
                {amc.name}
              </div>

              <div className="text-green-100 mt-2">
                Platform: {amc.platform}
              </div>

            </div>

          </div>

        </div>


        {/* BODY */}

        <div className="p-8">

          <div className="mb-8 text-gray-600 leading-8">
            {amc.description}
          </div>


          {/* FEATURES */}

          <div className="grid md:grid-cols-3 gap-4 mb-10">

            {amc.features.map((f, idx) => (

              <div
                key={idx}
                className="
                  bg-green-50
                  border
                  border-green-100
                  rounded-2xl
                  p-5
                  text-center
                  font-semibold
                  text-green-800
                "
              >
                {f}
              </div>

            ))}

          </div>


          {/* ACTIONS */}

          <div className="grid md:grid-cols-3 gap-5">

            <a
              href={amc.webLink}
              target="_blank"
              rel="noreferrer"
            >

              <div
                className="
                  bg-green-700
                  hover:bg-green-800
                  text-white
                  rounded-2xl
                  p-6
                  text-center
                  transition-all
                "
              >

                <Globe
                  size={32}
                  className="mx-auto mb-4"
                />

                <div className="font-bold text-lg">
                  Invest Online
                </div>

              </div>

            </a>


            <a
              href={amc.mobileLink}
              target="_blank"
              rel="noreferrer"
            >

              <div
                className="
                  border-2
                  border-green-700
                  text-green-700
                  rounded-2xl
                  p-6
                  text-center
                "
              >

                <Smartphone
                  size={32}
                  className="mx-auto mb-4"
                />

                <div className="font-bold text-lg">
                  Mobile Link
                </div>

              </div>

            </a>


            <div
              className="
                border
                rounded-2xl
                p-6
                text-center
              "
            >

              <QrCode
                size={32}
                className="mx-auto mb-4 text-green-700"
              />

              <img
                src={amc.qr}
                alt="QR"
                className="
                  w-32
                  h-32
                  object-contain
                  mx-auto
                "
              />

            </div>

          </div>

        </div>

      </div>

    </div>

  );
};


// ======================================================
// MAIN PAGE
// ======================================================

const MFPartnersPage = () => {

  const [selectedAMC, setSelectedAMC] =
    useState(null);

  return (

    <div className="bg-[#f5f7f5] min-h-screen">

      {/* ======================================================
          HERO
      ====================================================== */}

      <div className="relative">

        <NAV activetag="mf" />

        <div className="pt-[550px]">

          <MFSubnav active="partners" />

          <Carousel activetag="mf" />


          {/* OVERLAY */}

          <div
            className="
              absolute
              inset-0
              bg-gradient-to-b
              from-black/60
              via-black/40
              to-black/10
            "
          />


          {/* HERO CONTENT */}

          <div
            className="
              absolute
              inset-0
              flex
              items-center
            "
          >

            <div
              className="
                w-full
                px-6
                lg:px-12
                xl:px-20
              "
            >

              <div className="max-w-5xl">

                <div
                  className="
                    inline-flex
                    items-center
                    gap-2
                    px-4
                    py-2
                    rounded-full
                    bg-white/10
                    backdrop-blur-md
                    border
                    border-white/20
                    text-white
                    mb-6
                  "
                >
                  <Sparkles size={18} />
                  Orion Analytics Distribution Network
                </div>

                <h1
                  className="
                    text-5xl
                    lg:text-7xl
                    font-black
                    text-white
                    leading-tight
                    mb-6
                  "
                >
                  Invest Through
                  <span className="block text-green-400">
                    Trusted AMCs
                  </span>
                </h1>

                <p
                  className="
                    text-white/85
                    text-lg
                    lg:text-xl
                    max-w-3xl
                    leading-relaxed
                  "
                >
                  Orion Analytics is empanelled
                  with leading mutual fund
                  houses and investment
                  platforms enabling secure and
                  seamless investing.
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* FLOATING WIDGET */}

      <MFFloatingAdvisorWidget />
      {/* ======================================================
          TRUST STRIP
      ====================================================== */}

      <section className="px-6 lg:px-12 -mt-16 relative z-20">

        <div
          className="
            max-w-7xl
            mx-auto
            bg-white
            rounded-[32px]
            shadow-xl
            grid
            md:grid-cols-4
            overflow-hidden
          "
        >

          {[
            {
              icon: ShieldCheck,
              title: "ARN Registered",
            },

            {
              icon: Landmark,
              title: "Multi-AMC Access",
            },

            {
              icon: Building2,
              title: "Trusted Platforms",
            },

            {
              icon: Sparkles,
              title: "Research Driven",
            },

          ].map((item, idx) => (

            <div
              key={idx}
              className="
                p-8
                border-r
                last:border-r-0
                text-center
              "
            >

              <item.icon
                className="
                  mx-auto
                  mb-4
                  text-green-700
                "
                size={40}
              />

              <div className="font-bold text-lg">
                {item.title}
              </div>

            </div>

          ))}

        </div>

      </section>


      {/* ======================================================
          AMC GRID
      ====================================================== */}

      <section className="py-24 px-6 lg:px-12">

        <div className="max-w-7xl mx-auto">

          <div className="mb-16">

            <div
              className="
                text-5xl
                font-black
                mb-5
              "
            >
              AMC Partner Network
            </div>

            <div
              className="
                text-gray-500
                text-lg
                max-w-3xl
              "
            >
              Access investment platforms,
              SIP onboarding, and secure
              mutual fund investing through
              Orion Analytics partner
              ecosystem.
            </div>

          </div>


          <div
            className="
              grid
              md:grid-cols-2
              xl:grid-cols-3
              gap-8
            "
          >

            {amcPartners.map((amc) => (

              <div
                key={amc.id}
                className="
                  bg-white
                  rounded-[32px]
                  p-8
                  shadow-lg
                  hover:-translate-y-2
                  hover:shadow-2xl
                  transition-all
                  duration-300
                "
              >

                <div
                  className="
                    flex
                    items-center
                    gap-5
                    mb-8
                  "
                >

                  <img
                    src={amc.logo}
                    alt={amc.name}
                    className="
                      w-20
                      h-20
                      rounded-2xl
                      object-contain
                      border
                      p-2
                    "
                  />

                  <div>

                    <div
                      className="
                        text-2xl
                        font-black
                      "
                    >
                      {amc.name}
                    </div>

                    <div className="text-green-700">
                      {amc.platform}
                    </div>

                  </div>

                </div>


                <div
                  className="
                    text-gray-600
                    leading-7
                    mb-8
                  "
                >
                  {amc.description}
                </div>


                <div
                  className="
                    flex
                    flex-wrap
                    gap-3
                    mb-10
                  "
                >

                  {amc.features.map((f, idx) => (

                    <div
                      key={idx}
                      className="
                        px-4
                        py-2
                        rounded-full
                        bg-green-50
                        text-green-700
                        text-sm
                        font-semibold
                      "
                    >
                      {f}
                    </div>

                  ))}

                </div>


                <button
                  onClick={() =>
                    setSelectedAMC(amc)
                  }
                  className="
                    w-full
                    bg-green-700
                    hover:bg-green-800
                    text-white
                    py-4
                    rounded-2xl
                    font-bold
                    flex
                    items-center
                    justify-center
                    gap-2
                    transition-all
                  "
                >

                  Open Investment Options

                  <ChevronRight size={18} />

                </button>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* ======================================================
          INVESTMENT FLOW
      ====================================================== */}

      <section className="py-24 px-6 lg:px-12 bg-white">

        <div className="max-w-7xl mx-auto">

          <div className="text-center mb-20">

            <div
              className="
                text-5xl
                font-black
                mb-5
              "
            >
              Investment Journey
            </div>

            <div className="text-gray-500 text-lg">
              Simple and research-driven
              investing workflow
            </div>

          </div>


          <div
            className="
              grid
              md:grid-cols-5
              gap-8
            "
          >

            {[
              "Explore Funds",
              "Analyze Performance",
              "Select AMC",
              "Complete KYC",
              "Start Investing",
            ].map((step, idx) => (

              <div
                key={idx}
                className="text-center"
              >

                <div
                  className="
                    w-20
                    h-20
                    rounded-full
                    bg-green-700
                    text-white
                    flex
                    items-center
                    justify-center
                    mx-auto
                    text-3xl
                    font-black
                    mb-6
                  "
                >
                  {idx + 1}
                </div>

                <div
                  className="
                    text-xl
                    font-bold
                  "
                >
                  {step}
                </div>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* ======================================================
          CTA
      ====================================================== */}

      <section
        className="
          py-24
          px-6
          lg:px-12
          bg-gradient-to-r
          from-green-900
          to-green-700
          text-white
          text-center
        "
      >

        <div className="max-w-4xl mx-auto">

          <div
            className="
              text-5xl
              font-black
              mb-6
            "
          >
            Need Help Selecting Funds?
          </div>

          <div
            className="
              text-white/80
              text-xl
              mb-10
            "
          >
            Speak with Orion Analytics
            advisory desk for personalized
            mutual fund guidance.
          </div>


          <div
            className="
              flex
              flex-wrap
              justify-center
              gap-5
            "
          >

            <button
              className="
                bg-white
                text-green-800
                px-8
                py-4
                rounded-2xl
                font-bold
                text-lg
              "
            >
              Talk To Advisor
            </button>


            <a href="/mfe/">

              <button
                className="
                  border-2
                  border-white
                  px-8
                  py-4
                  rounded-2xl
                  font-bold
                  text-lg
                "
              >
                Explore Funds
              </button>

            </a>

          </div>

        </div>

      </section>


      {/* MODAL */}

      {/*<AMCModal*/}
      {/*  amc={selectedAMC}*/}
      {/*  onClose={() =>*/}
      {/*    setSelectedAMC(null)*/}
      {/*  }*/}
      {/*/>*/}

      <MFInvestmentModal
      open={!!selectedAMC}
      onClose={() => setSelectedAMC(null)}
      fund={{
        canonical_name: selectedAMC?.name || "Mutual Fund Investment",
      }}
    />

    </div>

  );
};

export default MFPartnersPage;